import * as React from "react";
import { Segment, Header, Checkbox, Dropdown, Form, Button, Message } from "semantic-ui-react";
import Rule from "../api/models/Rule";
import Update from "../api/models/Update";
import { CheckboxProps } from "semantic-ui-react/dist/commonjs/modules/Checkbox/Checkbox";
import {failOnNotOk, responseAsJson} from "../utils/fetch-helper";

interface IOwnState {
	allRules?: Rule[],
	selectedRules?: number[]
	selectedStatus?: number;
	Note?: string;
	Password?: string;
	Error?: string;
}

export default class AdminPage extends React.Component<null, IOwnState> {
	constructor(props:any) {
		super(props);
		this.state = {}
	}

	componentDidMount() {
		fetch("/api/rules")
			.then(r => failOnNotOk(r, null))
			.then(r => responseAsJson<Rule[]>(r))
			.then(r => this.setState({allRules: r.sort((a, b) => a.IsPositive ? -1 : 1), selectedRules: []}));
	}

	handleChange = (e: any, { name, value }: any) => this.setState({ [name]: value });

	handleRuleChange = (e:any, v:CheckboxProps) => {
		if (v.checked)
			this.setState({ selectedRules: this.state.selectedRules.concat([v.value as number])})
		else
			this.setState({ selectedRules: this.state.selectedRules.filter(r => r != v.value as number)})
	}

	submit = () => {
		const headers = new Headers();
		headers.append("Content-Type", "application/json");

		fetch("/api/update", {
			method: "POST",
			headers: headers,
			body: JSON.stringify({
				Password: this.state.Password,
				Status: this.state.selectedStatus,
				Note: this.state.Note,
				Rules: this.state.selectedRules
			})
		})
		.then(r => failOnNotOk(r, null))
		.then(r => responseAsJson<Rule[]>(r))
		.then(r => {
			if (r)
				window.location.href = "/";
		})
		.catch(err => {
			this.setState({Error: "Nuh uh"})
		})
	}

	render() {
		return (
			<div style={{ paddingTop: "1em" }}>
				<Segment>
					<Header as="h2">Update Status Manually</Header>

					<Form onSubmit={this.submit}>
						<Form.Dropdown required label="Status" placeholder='Select Status' fluid selection options={[
							{ text: "Definitely NO", value: 1 },
							{ text: "Technically NO, but...", value: 2 },
							{ text: "Definitely YES", value: 3 },
							{ text: "Technically YES, but...", value: 4 },
						]} onChange={(e, d) => this.setState({selectedStatus: d.value as number})} />

						<Form.Group grouped>
							<label>Reasons</label>
							{this.state && this.state.allRules && this.state.allRules.map(r => 
								<Form.Checkbox key={r.RuleID} value={r.RuleID}
									label={<label><b>{r.Name} ({r.IsPositive ? "+" : "-"})</b><br />{r.Description}</label>} 
									onChange={this.handleRuleChange}/>
							)}
						</Form.Group>

						<Form.TextArea placeholder='Optional note' label="Note"
							name="Note" fluid onChange={this.handleChange} />

						<Form.Input iconPosition='left' icon="lock" placeholder='Password' label="Password"
							name="Password" required fluid type="password" onChange={this.handleChange} />

						<Message negative hidden={!this.state.Error}>{this.state.Error}</Message>

						<Form.Button positive size="large">Update Status</Form.Button>
					</Form>				
				</Segment>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Admin/Admin.tsx